import styled from 'styled-components'
import breakPoint from 'theme/breakpoints'

export const Title = styled.h1`
    color: #161616;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 1.5rem */
    margin-top: 1rem;
    margin-bottom: 0.5rem;

    ${breakPoint.desktop} {
        margin-top: 2rem;
        margin-bottom: 1rem;
        font-size: 1.5rem;
        line-height: 133%; /* 1.995rem */
    }
`
export const Subtitle = styled.p`
    color: #666;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 170%; /* 1.4875rem */

    ${breakPoint.desktop} {
        font-size: 1rem;
        line-height: 150%; /* 1.5rem */
    }
`

export const Wrapper = styled.form`
    height: auto;
    max-width: 434px;
`
